
<div class="relative" *ngIf="showMenu">
    <div   class="drop-down  w-72   bg-vivid-royal-700 rounded-md shadow-md absolute top-5 -left-72  p-5 overflow-visible z-50" >
   
        <div class="w-0 h-0 absolute top-0 left-72
border-t-[20px] border-t-transparent
border-l-[15px] border-l-vivid-royal-400
border-b-[20px] border-b-transparent">
</div>
        <span class="text-white underline text-xl  font-medium mb-10">AÑADIR PANEL</span>
        <ul>
            @for (item of paneles; track $index) {
          <li #optionMenu class=" py-3 text-sm font-medium block items-center space-y-2 cursor-pointer" (click)="item.hidden=false;showPanel(item)" *ngIf="item.hidden">
           <span class="font-medium text-white text-lg w-full block ">{{item.title}}</span>
           
          </li>
        }
        
        </ul>
       
        
      </div>
</div>
<button   (click)="showMenu=true" class="rounded-full w-16 h-16 bg-orange_light p-2 flex items-center text-dark-khaki-50 dark:text-vivid-royal-950 mr-5 text-center text-lg "><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-10 text-center flex items-center w-full"><path d="M5 12h14"/><path d="M12 5v14"/></svg></button>